export const isUserFirefox = () => {
  return navigator.userAgent.includes('Firefox');   
};

